<template>
  <div id="header">
    <div class="header-container">
      <div class="header-item align-left">
        <h1 class="logo">
          <router-link to="userApply">
            <img src="@/assets/images/logo_blue.png" alt="신한금융지주회사" />
            <div style="font-size: 20px; text-align: right; margin-top: -20px;">관리자 포털</div>
          </router-link>
        </h1>
      </div>
      <div class="header-item align-center">
        <nav class="user-nav item-content">
          <ul v-for="nav in navList" :key="nav.url">
            <li @click="navClick(nav)" :class="{ 'on': nav.label == selectNav }">
              <a>{{ nav.label }}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="header-item ml-auto">
        <ul class="item-content">
          <li>
            <div v-if="this.userName" class="user-area"><span class="name">{{ this.userName }}</span></div>
          </li>
          <li>
            <a @click="logout">
              <i class="icon-fux-logout"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@/store/types';

export default {
  data() {
    return {
      navList: [],
      selectNav: '',
      authSessionId: this.$store.state.auth,
      //serverApiRoot: '',
      serverApiRoot: this.$store.state.serverApiRoot,
      userName: '',
    }
  },
  computed: {
    ...mapGetters({
      getNavList: types.GET_NAVLIST,
      getSelectNav: types.GET_CURRNAV,
      getServerApiRoot: types.GET_SERVERAPIROOT,
    }),
  },
  mounted() {
    this.navList = this.getNavList;
    this.selectNav = this.getSelectNav;
    //this.serverApiRoot = this.getServerApiRoot;
    // const payload = {
    //   'serverApiRoot': this.serverApiRoot
    // }
    // this.checkUserInfo(payload);
    if (this.serverApiRoot == '' || this.serverApiRoot == null) {
      this.serverApiRoot = `${window.location.protocol}//${window.location.hostname}`;
      const apiUrl = {
        "http://10.243.244.132": "http://10.243.244.132:8091",
        "http://10.243.244.133": "http://10.243.244.133:8091",
        "http://10.243.244.134": "http://10.243.244.134:8091",
        "http://10.243.244.135": "http://10.243.244.135:8091",
        "http://20.214.155.54": "http://20.214.155.54:8091",
        // "https://cloudpc.shinhangroup.com": "https://dev.cloudpc.shinhangroup.com",
        "https://cloudpc.shinhangroup.com": "https://view.cloudpc.shinhangroup.com",
        "http://localhost": "http://localhost:8093",
      };
      this.serverApiRoot = apiUrl[this.serverApiRoot];
      //sessionStorage.setItem("serverApiRoot", this.serverApiRoot);
      this.$store.commit('SET_SERVERAPIROOT', this.serverApiRoot);
    }

    if (!this.authSessionId) {
      alert("잘못된 접근입니다.");
      this.$router.push({
        name: "login"
      });
    } else {
      this.loginCheck();
    }
  },
  methods: {
    ...mapGetters({
      getUserInfo: types.GET_USERINFO,
    }),
    ...mapMutations({
      setSelectNav: types.SET_CURRNAV
    }),
    logout() {
      this.$axios
        .get(`${this.serverApiRoot}/logout/`, {
          withCredentials: true, 
        })  
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //sessionStorage.clear();
            this.$router.push({
              name: "login",
            });
          } else {
            alert('로그아웃 실패');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    navClick(nav) {
      this.setSelectNav(nav.label);
      this.selectNav = this.getSelectNav;
      this.loginCheck();
      this.$router.push(nav.url);
    },
    loginCheck() {
      if (this.getServerApiRoot == '' || this.getServerApiRoot == null) {
        this.serverApiRoot = `${window.location.protocol}//${window.location.hostname}`;
        const port = {
          "http://10.243.244.132": "http://10.243.244.132:8091",
          "http://10.243.244.133": "http://10.243.244.133:8091",
          "http://10.243.244.134": "http://10.243.244.134:8091",
          "http://10.243.244.135": "http://10.243.244.135:8091",
          "http://20.214.155.54": "http://20.214.155.54:8091",
          // "https://cloudpc.shinhangroup.com": "https://dev.cloudpc.shinhangroup.com",
          "https://cloudpc.shinhangroup.com": "https://view.cloudpc.shinhangroup.com",
          "http://localhost": "http://localhost:8091",
        };
        this.serverApiRoot = port[this.serverApiRoot];
        this.$store.commit('SET_SERVERAPIROOT', this.serverApiRoot);
      }

      this.$axios
        .get(`${this.serverApiRoot}/check_session/`, {
          withCredentials: true, 
        })
        .then((response) => {
          if (response.status == 200 && response.data != '' && response.data != null) {
            let obj = response.data;
            if (obj.msg == 'Success' && obj.result != '') {
              this.userName = obj.result.userName;
              return false;
            }
          } 
          
          this.logout();
        })
        .catch((error) => {
          console.log(error)
          alert(error.msg);
        });
    },
  }
}
</script>
